import { integrationsApi } from '../api/misc';
import { whatsappService } from '../services/whatsappService';

/**
 * Initialize WAHA service from database settings
 * Call this on app startup
 */
export const initializeWaha = async () => {
    try {
        const row = await integrationsApi.get('waha').catch(() => null);
        const settings = (row as any)?.settings;

        if (settings?.apiUrl) {
            // Configure service
            whatsappService.configure({
                baseUrl: settings.apiUrl,
                apiKey: settings.apiKey
            });

            console.log(`[WAHA] Initialized with URL: ${settings.apiUrl}`);
            return true;
        } else {
            console.warn('[WAHA] No settings found in DB.');
        }

        return false;
    } catch (err) {
        console.error('[WAHA] Failed to initialize:', err);
        return false;
    }
};
